module.exports = __webpack_public_path__ + "static/img/02.b47b2a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/alpa_bern/02.jpg
// module id = 351
// module chunks = 1